<template>
  <div :class="$style.container">
    <div :class="$style.content">

      <div :class="$style.header">
        <div :class="$style.title">
          <h1
            v-m-b="5"
            v-cursor="isPersonalProject ? 'pointer' : 'default'"
            @click="handleClickToEditProject"
            v-text="project.name"
          ></h1>
          <a
            v-opacity=".5"
            :href="project.link"
            target="_blank"
            rel="noopener nofollow"
            v-text="projectLink"
          ></a>
        </div>

        <project-safe-deal
          v-if="project.safeDeal"
          v-m-r="20"
          v-m-l="10"
          :project="project"
        ></project-safe-deal>

        <div
          :class="$style.logo"
          @click="handleClickToEditProject"
        >
          <project-logo
            :project="project"
            size="lg"
          ></project-logo>
        </div>
      </div>

      <div
        v-if="isPersonalProject"
        :class="$style.navigation"
      >
        <graph-button
          v-if="graph.length > 0"
          @click="handleClickToGraph"
        ></graph-button>

        <subscribers-counter-button
          v-if="isActiveRecurrent"
          v-m-l="10"
          :subscriber-count="project.subscriberCount"
          @click="handleClickToSubscriptions"
        ></subscribers-counter-button>

        <div
          v-grow="1"
          :class="$style.payout"
        >
          <simple-button
            variant="pinky"
            :disabled="isInactiveProject"
            @click="$router.push({ name: 'payout' })"
          >
            {{ displayBalance }}
          </simple-button>
        </div>
      </div>

      <div
        v-else-if="isPartnerProject"
        :class="$style.badge"
        v-text="$t('common.partner')"
      ></div>
    </div>
  </div>
</template>

<script>
import { formatAmount } from 'lib/utils/amount';

import ProjectService from 'services/project';

import SimpleButton from 'molecules/common/SimpleButton';
import ProjectLogo from 'molecules/project/ProjectLogo';
import GraphButton from 'molecules/project/GraphButton';
import SubscribersCounterButton from 'molecules/project/SubscribersCounterButton';
import ProjectSafeDeal from 'organisms/project/ProjectSafeDeal';

import { URL_PROTOCOL } from 'definitions/url';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'ProjectInformationMobileTemplate',
  components: {
    ProjectLogo,
    SimpleButton,
    GraphButton,
    SubscribersCounterButton,
    ProjectSafeDeal,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
    graph: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    projectLink() {
      const { link } = this.project;

      if (URL_PROTOCOL.test(link)) {
        return link.replace(URL_PROTOCOL, '');
      }

      return link;
    },
    isPersonalProject() {
      return ProjectService.checkPersonalProject(this.project);
    },
    isPartnerProject() {
      return ProjectService.checkPartnerProject(this.project);
    },
    isActiveRecurrent() {
      if (ProjectService.checkRecurrentPaymentPermission(this.project)) {
        return true;
      }

      return ProjectService.checkPeriodicRecurrentPaymentPermission(this.project);
    },
    isInactiveProject() {
      return ProjectService.checkInactiveStatus(this.project);
    },
    displayBalance() {
      const { balance, currency } = this.project;

      return formatAmount(balance, currency);
    },
  },
  methods: {
    handleClickToEditProject() {
      if (this.isPersonalProject) {
        this.$router.push({ name: 'editProject' });
      }
    },
    handleClickToSubscriptions() {
      if (ProjectService.checkSubscriptionsPermission(this.project)) {
        this.$router.push({ name: 'subscriptions' });
      }
    },
    handleClickToGraph() {
      EVENT_BUS.$emit('EVENT_TOOGLE_GRAPH_SHOW');
    },
  },
};
</script>

<style lang="sass" module>
  .container
    padding: 20px 24px
    background: #27283C
    box-shadow: 0px 0px 7px rgba(0, 0, 0, .15)

    +respond-to('small')
      border-radius: 5px

  .content
    +flexbox
    +flex-direction(column)

  .header
    +flexbox
    margin-bottom: 20px

  .title
    +flexbox
    +flex-direction(column)
    overflow: hidden

    h1
      +font-type('regular', 20, 24)
      margin: 0
      color: var(--color-white)
      word-break: break-word

    a
      +font-type('medium', 14, 20)
      +text-ellipsis
      color: var(--color-white)

  .logo
    margin-left: auto

  .badge
    +font-type('medium', 14, 20)
    align-self: flex-start
    padding: 5px 20px
    color: var(--color-black)
    background: linear-gradient(249.76deg, #37B55E -8.32%, #7BD3FF 108.85%), #FFFFFF
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15)
    border-radius: 50px

  .navigation
    +flexbox
    +justify-content(end)

  .payout
    min-width: 100px
    margin-left: 20px
</style>
